var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',{staticClass:"pd-auto"},[_c('img',{staticClass:"img-fluid main-banner",attrs:{"src":require("../../assets/images/new_banner2.jpg")}})])])])])
}]

export { render, staticRenderFns }